
export default {
    onShareAppMessage () {
        const sub_page = encodeURIComponent(`/pages/building/value_analysis/main?building_id=${this.building_id}`)
        return this.getShareInfo({
            title: `深度测评，全面分析，【${this.house.name}】楼盘价值分析报告~`,
            path: `/pages/building/main?building_id=${this.building_id}&sub_page=${sub_page}`,
        })
    }
}